// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseModel } from './caseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CaseSearchResultModelCaseCaseModel {
    'results'?: Array<CaseModel>;
    'hasAdditionalResults'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseSearchResultModelCaseCaseModel>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<CaseModel>"
        },
        {
            "name":     "hasAdditionalResults",
            "baseName": "hasAdditionalResults",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return CaseSearchResultModelCaseCaseModel.attributeTypeMap;
    }
}
